import React, { useState, useEffect } from "react"
// import "../styles/table.css";
import Footer from "../components/footer"
import { createGlobalStyle } from "styled-components"
import Menu from "./menu"
import { Form, Input, Modal, Select, Button } from "antd"
import { BaseUrl } from "../utils/config"
import { useNavigate } from "@reach/router"
import {
  BrowserRouter as Router,
  Link,
  useHistory,
  useLocation
} from "react-router-dom"
import axios from "axios"
import swal from "sweetalert"
import moment from "moment"
import { useDispatch, useSelector } from "react-redux"
import {
  setConnectedWallet,
  updateUserDetailsRedux,
  setActiveMenu
} from "../../redux/actions"
import { useLogout } from "../../hooks"
import { IoTUrl } from "../../utils/config"

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.white {
    background: #212428;
  }
`

const Profile = () => {
  const userDetails = useSelector(state => state.common.userDetails)
  const [allproducts, setAllproducts] = useState([])
  const [viewProduct, setViewProduct] = useState(false)
  const loginUserMail = localStorage.getItem("loginUserMail")
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const logoutHandler = useLogout()

  useEffect(() => {
    axios
      .get(`${BaseUrl}/product/get`)
      .then(response => {
        setAllproducts(response.data.data)
        if (response.status == 200) {
          setAllproducts(response.data.data)
        } else if (response.status == 401) {
          logoutHandler()
        } else if (response.status == 404) {
          swal({
            title: "Error!",
            text: "Page not found. Please try again later.",
            icon: "error"
          })
        } else if (response.status == 500) {
          swal({
            title: "Error!",
            text: "Something went wrong. Please try again later.",
            icon: "error"
          })
        } else if (response.status == 503) {
          swal({
            title: "Error!",
            text: "Something went wrong. Please try again later.",
            icon: "error"
          })
        } else {
        }
      })
      .catch(error => {
        if (error?.response?.status == 401) {
          logoutHandler()
        }
      })
  }, [])

  const onviewproduct = id => {
    setViewProduct(true)
    // SetSelectedId(id);
    navigate("/productdetails", { state: { selectedId: id } })
  }
  const toLogin = () => {
    navigate("/login")
  }
  const toChangePage = item => {
    navigate(`/${item}`)
  }

  return (
    <div className="">
      {/* <GlobalStyles/> */}
      <section className="jumbotron breadcumb no-bg">
        <div className="">
          <div className="container">
            <div className="row m-10-hor">
              <div className="col-12 mt-4">
                <h1 className="text-center my-profile-text mt-4">My Profile</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="backgroundColordark ">
        <div className=" row  pt-md-4 d-flex justify-content-center">
          <div className="profile-section">
            <div className="profile-box">
              <div className="profile-image">
                {/* <img src="./images/profile.jpg" alt="" /> */}

                {userDetails?.loginUser?.charAt(0) ?? ""}
              </div>

              <h1>{userDetails?.loginUser}</h1>
              <p>{userDetails?.loginUserMail}</p>

              <div className="btns-profiles">
                <a
                  onClick={() => toChangePage("editprofile")}
                  className="btn-submit">
                  Edit Profile
                </a>
                <a
                  onClick={() => toChangePage("changepassword")}
                  className="btn-submit">
                  Reset Password
                </a>
                <a
                  href={`${IoTUrl}${
                    userDetails?.referralId
                      ? `?referralID=${userDetails?.referralId}`
                      : ""
                  }`}
                  className="text-white"
                  style={{ textDecoration: "underline" }}>
                  Your Referral ID: {userDetails?.referralId}
                </a>
              </div>
            </div>
          </div>

          <div className="spacer-double"></div>

          {/* <ul className="pagination justify-content-center ">
                <li className="active"><span>1 - 20</span></li>
                <li><span>21 - 40</span></li>
                <li><span>41 - 60</span></li>
            </ul>  */}
        </div>
      </section>

      {/* <Footer /> */}
    </div>
  )
}
export default Profile
